var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpArtPictureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-art-picture-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.667,
    y: 5.725,
    width: 43.333,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.667,
    y: 24.296,
    width: 43.333,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 61.439,
    width: 21.667,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 61.439,
    width: 43.333,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.667,
    y: 98.582,
    width: 43.333,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.667,
    y: 117.153,
    width: 43.333,
    height: 18.571,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 117.153,
    x2: 5,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.333,
    y1: 117.153,
    x2: 48.333,
    y2: 135.724,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.666,
    y1: 117.153,
    x2: 91.666,
    y2: 135.724,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 117.153,
    x2: 134.999,
    y2: 135.724,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 117.153,
    x2: 5,
    y2: 135.724,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 98.581,
    x2: 70,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.333,
    y1: 98.581,
    x2: 113.333,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.667,
    y1: 98.581,
    x2: 26.667,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 98.581,
    x2: 5,
    y2: 98.581,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 98.581,
    x2: 5,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.333,
    y1: 80.01,
    x2: 48.333,
    y2: 98.581,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.666,
    y1: 80.01,
    x2: 91.666,
    y2: 98.581,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 80.01,
    x2: 134.999,
    y2: 98.581,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 80.01,
    x2: 5,
    y2: 98.581,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 61.439,
    x2: 70,
    y2: 80.01,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.333,
    y1: 61.439,
    x2: 113.333,
    y2: 80.01,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.667,
    y1: 61.439,
    x2: 26.667,
    y2: 80.01,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 61.439,
    x2: 5,
    y2: 61.439,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 61.439,
    x2: 5,
    y2: 80.01,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 42.868,
    x2: 5,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.333,
    y1: 42.868,
    x2: 48.333,
    y2: 61.439,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.666,
    y1: 42.868,
    x2: 91.666,
    y2: 61.439,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 42.868,
    x2: 134.999,
    y2: 61.439,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 42.868,
    x2: 5,
    y2: 61.439,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 24.296,
    x2: 70,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.333,
    y1: 24.296,
    x2: 113.333,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.667,
    y1: 24.296,
    x2: 26.667,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 24.296,
    x2: 5,
    y2: 24.296,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 24.296,
    x2: 5,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.681,
    y1: 5.725,
    x2: 5,
    y2: 5.725,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.333,
    y1: 5.725,
    x2: 48.333,
    y2: 24.296,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.666,
    y1: 5.725,
    x2: 91.666,
    y2: 24.296,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 5.725,
    x2: 134.999,
    y2: 24.296,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5.725,
    x2: 5,
    y2: 24.296,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 98.581,
    x2: 134.999,
    y2: 117.153,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 61.439,
    x2: 134.999,
    y2: 80.01,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 24.296,
    x2: 134.999,
    y2: 42.868,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.999,
    y1: 5.725,
    x2: 79.318,
    y2: 5.725,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.319,
    y1: 5.725,
    x2: 66.68,
    y2: 5.725,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.509,135.724H5m130,0H124.146m-6,0h-6.639",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.525,80.01H5m130,0H44.163m-5,0h-2.64",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.168 48.352 70.085 21.485 114.035 43.734",
    style: {
      fill: "none",
      stroke: "#50505a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px",
      fillRule: "evenodd",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.998 49.352 120 43.353 125.998 49.352 125.998 124.351 25.998 124.351 20 118.352 25.998 49.352",
    style: {
      fill: "#3c3c46",
      fillRule: "evenodd",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48.352,
    width: 100,
    height: 70,
    style: {
      fill: "#3ca5f0",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43.353,
    width: 100,
    height: 70,
    style: {
      fill: "#8adafc"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.611,
    y1: 60.685,
    x2: 49.192,
    y2: 60.685,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.712,
    y1: 60.551,
    x2: 84.982,
    y2: 60.551,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.961,
    y1: 60.686,
    x2: 120,
    y2: 60.686,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.611,
    y1: 70.038,
    x2: 40.339,
    y2: 70.038,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.544,
    y1: 70.038,
    x2: 93.961,
    y2: 70.038,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.043,
    y1: 70.038,
    x2: 119.002,
    y2: 70.038,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.611,
    y1: 79.392,
    x2: 31.378,
    y2: 79.392,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.02,
    y1: 79.391,
    x2: 103.066,
    y2: 79.391,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.793,
    y1: 79.526,
    x2: 119.001,
    y2: 79.526,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.252,
    y1: 88.879,
    x2: 119.002,
    y2: 88.879,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.732,
    y1: 89.012,
    x2: 99.273,
    y2: 89.012,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.921,
    y1: 89.012,
    x2: 86.879,
    y2: 89.012,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.611,
    y1: 89.012,
    x2: 40.339,
    y2: 89.012,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.611,
    y1: 98.366,
    x2: 119.001,
    y2: 98.366,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.383,
    y1: 89.012,
    x2: 55.924,
    y2: 89.012,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.352,
    y1: 70.038,
    x2: 72.769,
    y2: 70.038,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.126,
    y1: 79.392,
    x2: 50.893,
    y2: 79.392,
    style: {
      fill: "none",
      stroke: "#3ca5f0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.169,43.353,70.085,21.485M120,43.353,70.085,21.485",
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.084,
    cy: 26.296,
    r: 2.811,
    style: {
      fill: "#3c3c46",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.085,
    cy: 24.296,
    r: 2.811,
    style: {
      fill: "#fff",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.367,92.524a7.712,7.712,0,0,0-2.744-2.144v-5.83A19.554,19.554,0,0,0,91.284,74.7v-.668a19.536,19.536,0,0,0-1-6.185l-.126-.376A3.908,3.908,0,0,0,86.441,64.8H86.33a3.874,3.874,0,0,0-2.033.582,15.522,15.522,0,0,0-13.853-8.563h-.888A15.522,15.522,0,0,0,55.7,65.378a3.874,3.874,0,0,0-2.033-.582h-.111a3.91,3.91,0,0,0-3.714,2.677l-.127.376a19.582,19.582,0,0,0-1,6.184V74.7a19.555,19.555,0,0,0,2.661,9.847v5.83a7.652,7.652,0,0,0-4.434,6.965V111.8H93.058V97.344A7.743,7.743,0,0,0,91.367,92.524Z",
    style: {
      fill: "#3c3c46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.284,110.025H81.529v-1.774H79.755v1.774H60.245V102.93H58.471v7.095H48.716V97.344a5.918,5.918,0,0,1,3.052-5.185l6.7,6.7v2.293h1.774V98.639l.045-.135a33.583,33.583,0,0,0,1.681-8.954,12.971,12.971,0,0,0,1.18.8l4.785,10.367a2.271,2.271,0,0,0,4.126,0l4.785-10.368a13.37,13.37,0,0,0,1.18-.8A33.542,33.542,0,0,0,79.711,98.5l.044.135v7.839h1.774V98.863l6.7-6.7a5.912,5.912,0,0,1,3.051,5.185Z",
    style: {
      fill: "#3ca5f0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.489,74.7v-.668A17.785,17.785,0,0,1,51.4,68.41l.126-.376a2.139,2.139,0,0,1,2.032-1.464h.111a2.116,2.116,0,0,1,1.318.467,15.389,15.389,0,0,0,.387,11.6l2.592,5.832a13.112,13.112,0,0,0,2.276,3.483,31.854,31.854,0,0,1-1.29,8.886l-5.8-5.8V84.061l-.127-.21A17.788,17.788,0,0,1,50.489,74.7Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.348,91.54l-3.895,8.44a.52.52,0,0,1-.906,0L65.653,91.54a13.017,13.017,0,0,0,8.7,0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.556,58.588h.888A13.744,13.744,0,0,1,83,77.915l-2.592,5.832a11.394,11.394,0,0,1-20.825,0L57,77.915a13.744,13.744,0,0,1,12.56-19.327Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.627,78.635a15.389,15.389,0,0,0,.387-11.6,2.112,2.112,0,0,1,1.317-.467h.111a2.139,2.139,0,0,1,2.032,1.464l.125.376a17.754,17.754,0,0,1,.913,5.623V74.7a17.782,17.782,0,0,1-2.534,9.148l-.127.211v6.973l-5.8,5.8a31.824,31.824,0,0,1-1.29-8.886,13.1,13.1,0,0,0,2.276-3.483Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.981,
    cy: 71.891,
    r: 4.434,
    style: {
      fill: "#3c3c46"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.981,
    cy: 71.891,
    r: 2.661,
    style: {
      fill: "#8adafc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.095,
    y: 71.004,
    width: 1.774,
    height: 1.774,
    style: {
      fill: "#3c3c46"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.018,
    cy: 71.891,
    r: 4.434,
    style: {
      fill: "#3c3c46"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.018,
    cy: 71.891,
    r: 2.661,
    style: {
      fill: "#8adafc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.131,
    y: 71.004,
    width: 1.774,
    height: 1.774,
    style: {
      fill: "#3c3c46"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.113,
    y: 70.117,
    width: 1.774,
    height: 7.095,
    style: {
      fill: "#3c3c46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,88.741c1.516,0,2.661-1.906,2.661-4.434S71.516,79.872,70,79.872s-2.661,1.906-2.661,4.434S68.483,88.741,70,88.741Z",
    style: {
      fill: "#3c3c46",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,81.646c.221,0,.887.943.887,2.66s-.666,2.661-.887,2.661-.887-.944-.887-2.661S69.779,81.646,70,81.646Z",
    style: {
      fill: "#f3424c",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.426,
    y: 106.628,
    width: 64.877,
    height: 6.871,
    style: {
      fill: "#8adafc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 43.353,
    width: 100,
    height: 70,
    style: {
      fill: "none",
      stroke: "#3c3c46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.0001px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpArtPictureIcon);
export default __webpack_public_path__ + "static/media/cp-art-picture-icon.8697d19f5ee7fa40634d3598e2e3ac09.svg";
export { ForwardRef as ReactComponent };